import { instantiateProjectTemplate } from './component-template'
import { normalizeTemplate } from '@/utils/templates'
import { screenCreatePayload, confirmScreenCreated } from '@/utils/screen-create'
import { createPageSavePayload } from '@/schema/page-project'
import { uuid } from '@/utils/utils'

// 一次新增携带整项目，成功后核对返回实体，避免新增后再分步保存。
export function projectTemplateCreatePayload (template, form, createId = uuid, type = 'big_screen') {
  const value = normalizeTemplate(template)
  if (value.kind !== 'project') throw new Error('当前模板不是项目模板')
  const record = screenCreatePayload(form, type)
  const project = instantiateProjectTemplate(value.snapshot, createId)
  const home = project.pages.find(page => page.id === project.homePageId)
  return { ...record, ...createPageSavePayload(record, {}, project, home.id, home.config, home.nodes) }
}

export const confirmProjectCreated = confirmScreenCreated
